
<span class="relative">
        <span  *ngIf="!showAvatar || !user.avatar" class="icon-size-8 material-symbols-outlined"> account_circle </span>
</span>


